<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="13"
		height="11"
		viewBox="0 0 13 11"
		fill="none"
	>
		<path
			d="M1 4.5L5.17241 10L12 1"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PrecartModalCheck',
};
</script>
